import { Column } from '@synqo/frontend-component-library';
import { ApiRentVariant } from '@Model';

export const rentVariantColumns: Column<ApiRentVariant>[] = [
    { name: 'shorthand', label: 'Suchcode' },
    { name: 'label', label: 'Bezeichnung' },
    { name: 'free_days_after_placement', label: 'Freie Tage nach Stellung' },
    { name: 'free_days_after_exchange', label: 'Freie Tage nach Tausch' },
];
